import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { brandingService } from "services";
import { uiActions } from "store";
import { ErrorResponse, DocumentData } from "types";

type UseAddBrandingMutationProps = {
	agentId: string;
	onSuccess?: Function;
	onError?: Function;
	refetch?: Function;
};

const useAddBrandingLogoAgentMutation = ({
	agentId,
	onSuccess,
	onError,
	refetch,
}: UseAddBrandingMutationProps) => {
	const dispatch = useDispatch();

	return useMutation(
		(document: DocumentData) => {
			return brandingService.addBrandingLogoAgent({
				agentId,
				document,
			});
		},
		{
			onSuccess(result) {
				refetch?.();
				dispatch(
					uiActions.showSuccessNotification({
						title: "Logo has been added successfully",
					}),
				);

				onSuccess?.(result);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: "Couldn't add a Logo",
					}),
				);
				onError?.(error);
			},
		},
	);
};

export default useAddBrandingLogoAgentMutation;
